module.exports = __webpack_public_path__ + "static/img/auto_verkaufen_lokal.1cd6817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base/auto_verkaufen_lokal.png
// module id = i0Q0
// module chunks = 1